export class usuario {
    rut_usuario: number;
    login: string;
    password: string;
    fecha_creacion: Date;
    fecha_modificacion: Date;
    mail: string;
    activo: boolean;
    nombre_completo: string;
    flag_cambioclave: boolean;
    max_conexiones_concurrentes: number;
}